export enum LoadingType {
  CARDS,
  LINES,
  HEADERS,
  PARAGRAPH,
  IMAGE,
  SPINNER,
}
